import { all, takeEvery, put, fork, call } from "redux-saga/effects";
import actions from "./actions";

export function* getGifts() {
  yield takeEvery(actions.FETCH_GIFTS_REQUESTED, function* (action) {
    try {
      const gifts = yield call(actions.getGifts, action.payload);

      yield put({ type: actions.FETCH_GIFTS_SUCCEEDED, gifts });
    } catch (error) {
      yield put({ type: actions.FETCH_GIFTS_FAILED, error: error.message });
    }
  });
}

export function* getGift() {
  yield takeEvery(actions.FETCH_GIFT_REQUESTED, function* (action) {
    try {
      const gift = yield call(actions.getGift, action.payload);
      yield put({
        type: actions.FETCH_GIFT_SUCCEEDED,
        gift: gift.gift_info,
      });
    } catch (error) {
      yield put({ type: actions.FETCH_GIFT_FAILED, error: error.message });
    }
  });
}

export function* searchGifts() {
  yield takeEvery(actions.SEARCH_GIFT_REQUESTED, function* (action) {
    try {
      const gifts = yield call(actions.searchGifts, action.payload);
      yield put({ type: actions.SEARCH_GIFT_SUCCEEDED, gifts });
    } catch (error) {
      yield put({ type: actions.SEARCH_GIFT_FAILED, error: error.message });
    }
  });
}

export function* deleteGift() {
  yield takeEvery(actions.DELETE_GIFT_REQUESTED, function* (action) {
    try {
      const gift = yield call(actions.deleteGift, action.payload);
      yield put({
        type: actions.DELETE_GIFT_SUCCEEDED,
        giftDeleted: gift,
      });
    } catch (error) {
      yield put({ type: actions.DELETE_GIFT_FAILED, error: error.message });
    }
  });
}

export default function* rootSaga() {
  yield all([
    fork(getGifts),
    fork(searchGifts),
    fork(getGift),
    fork(deleteGift),
  ]);
}
